import { render, staticRenderFns } from "./teamperformancepro.vue?vue&type=template&id=3f136192&scoped=true&"
import script from "./teamperformancepro.vue?vue&type=script&lang=js&"
export * from "./teamperformancepro.vue?vue&type=script&lang=js&"
import style0 from "./teamperformancepro.vue?vue&type=style&index=0&id=3f136192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f136192",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
